import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPedestrian = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.66667 15.3333L6.53333 5.93333L5.33333 6.4V8.66667H4V5.53333L7.36667 4.1C7.52222 4.03333 7.68611 3.99444 7.85833 3.98333C8.03056 3.97222 8.19444 3.99444 8.35 4.05C8.50556 4.10556 8.65278 4.18333 8.79167 4.28333C8.93056 4.38333 9.04444 4.51111 9.13333 4.66667L9.8 5.73333C10.0889 6.2 10.4806 6.58333 10.975 6.88333C11.4694 7.18333 12.0333 7.33333 12.6667 7.33333V8.66667C11.8889 8.66667 11.1944 8.50556 10.5833 8.18333C9.97222 7.86111 9.45 7.45 9.01667 6.95L8.6 9L10 10.3333V15.3333H8.66667V11L7.26667 9.93333L6.06667 15.3333H4.66667ZM9 3.66667C8.63333 3.66667 8.31944 3.53611 8.05833 3.275C7.79722 3.01389 7.66667 2.7 7.66667 2.33333C7.66667 1.96667 7.79722 1.65278 8.05833 1.39167C8.31944 1.13056 8.63333 1 9 1C9.36667 1 9.68056 1.13056 9.94167 1.39167C10.2028 1.65278 10.3333 1.96667 10.3333 2.33333C10.3333 2.7 10.2028 3.01389 9.94167 3.275C9.68056 3.53611 9.36667 3.66667 9 3.66667Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgPedestrian);
export default ForwardRef;
